const SplitScroll = () => ({
  scrollSyncEnabled: false,
  prevScroll: 0,
  direction: 'down',

  init() {
    document.addEventListener('scroll', () => {
      if (!this.scrollSyncEnabled) {
        return;
      }

      this.direction = this.prevScroll > window.scrollY ? 'up' : 'down';
      this.prevScroll = window.scrollY;

      const main = this.$refs.main.getBoundingClientRect();

      /* Do nothing when the main area is shorter than the window
       * Otherwise the aside scroll would be inverted and too fast.
       */
      if (main.height < window.innerHeight) {
        return;
      }

      const totalPercent = (-1 * main.top) / (main.height - window.innerHeight);

      const percent = Math.max(0, Math.min(totalPercent, 1));

      const aside = this.$refs.aside;
      const scrollTop = (aside.scrollHeight - aside.offsetHeight) * percent;

      if (
        (this.direction === 'down' && aside.scrollTop > scrollTop) ||
        (this.direction === 'up' && aside.scrollTop < scrollTop)
      ) {
        return;
      }

      aside.scrollTop = scrollTop;
    });
  }
});

export default SplitScroll;
